import React from 'react';
import { Modal } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import QRCode from 'react-qr-code';
import { t } from 'helpers/i18n';
import { getTerraEnv } from 'util/pandoraConfig';
import './ClientQrPopup.scss';

export interface PaymentControllerQrCodePopupProps {
  handleCloseModal: () => void;
}

function ClientQrPopup(props: PaymentControllerQrCodePopupProps) {
  const { selectedApp, selectedAppVersion } = useSelector(
    (state: RootState) => state.projectDetail
  );

  if (!selectedApp || !selectedAppVersion) return <></>;

  const clientId = `${selectedApp.product.code}:${selectedApp.platform.code}:${selectedApp.market.code}:${selectedAppVersion.code}`;

  const qrContent = makeQrContent(selectedApp.product.code, clientId);

  return (
    <Modal
      open={true}
      title={t('terra_app_qr_title')}
      footer={null}
      onCancel={props.handleCloseModal}
    >
      <div className="client-qr-container">
        <h2 style={{ color: '#06518F' }}>{selectedApp.product.name}</h2>
        <br />

        <div className="qr-border-corners">
          <div className="qr-border-top qr-border-left" />
          <div className="qr-border-top qr-border-right" />
          <div className="qr-border-bottom qr-border-right" />
          <div className="qr-border-bottom qr-border-left" />

          <QRCode size={180} value={qrContent} />
        </div>
        <br />
        <h4>{`${t('terra_app_qr_version')}: ${selectedAppVersion.code}`}</h4>
        <h4>{`${t('terra_app_qr_platform')}: ${selectedApp.platform.code}`}</h4>
      </div>
    </Modal>
  );
}

export default ClientQrPopup;

function makeQrContent(appName: string, clientId: string): string {
  const qrContent = {
    client_id: clientId, // client code
    app_name: appName, // merchant code on firestore to get data
    env: getTerraEnv(),
  };

  return window.btoa(JSON.stringify(qrContent));
}
